import { Controller } from "@hotwired/stimulus"

// Auto-rotating "Nossos eventos" banner carousel — ported from the
// original's EventsCarousel (src/components/EventsBanners.tsx). Only
// mounted when there are 2+ active banners; a single banner renders as a
// plain <img>, no carousel chrome at all.
const ROTATE_MS = 6000

export default class extends Controller {
  static targets = ["track", "slide", "dot"]

  connect() {
    this.index = 0
    this.startAutoplay()
  }

  disconnect() {
    this.stopAutoplay()
  }

  pause() {
    this.stopAutoplay()
  }

  resume() {
    this.startAutoplay()
  }

  prev() {
    this.go(this.index - 1)
  }

  next() {
    this.go(this.index + 1)
  }

  goToDot(event) {
    this.go(Number(event.currentTarget.dataset.index))
  }

  startAutoplay() {
    if (window.matchMedia?.("(prefers-reduced-motion: reduce)")?.matches) return
    this.stopAutoplay()
    this.timer = setInterval(() => this.go(this.index + 1), ROTATE_MS)
  }

  stopAutoplay() {
    clearInterval(this.timer)
  }

  go(index) {
    const count = this.slideTargets.length
    this.index = ((index % count) + count) % count
    this.trackTarget.style.transform = `translateX(-${this.index * 100}%)`
    this.slideTargets.forEach((slide, i) => slide.setAttribute("aria-hidden", String(i !== this.index)))
    this.dotTargets.forEach((dot, i) => {
      dot.classList.toggle("active", i === this.index)
      dot.setAttribute("aria-selected", String(i === this.index))
    })
  }
}
